import gql from 'graphql-tag'

export const mallStatisticsDocument = gql`
  query Order_statistics(
    $period: OrderStatisticPeriod,
    $pagination: PaginationInput
  ) {
    order_statistics(
      period: $period,
      pagination: $pagination
    ) {
      nodes {
        datetime
        order_count
        pay_channel_statistics {
          amounts
          frequency
        }
        platform_statistics {
          amounts
          frequency
        }
        revenue
        sku_statistics {
          names
          frequency
          amounts
        }
      }
    }
  }
`
